export default __webpack_public_path__ + "static/media/logo-white-bg.be6fbe2b.png";